import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'goa-signin-callout',
  templateUrl: './callout.component.html',
  styleUrls: ['./callout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalloutComponent {
  @Input() heading: string;
  // blue | green | yellow* | yellow* | red
  // *warning & important are the same
  @Input() type:
    | 'information'
    | 'event'
    | 'warning'
    | 'important'
    | 'emergency' = 'information';
}
